import type { Icon } from 'iconsax-reactjs';

/**
 * A volume profile: horizontal bars of differing length against a price axis.
 *
 * Drawn rather than borrowed because the iconsax chart glyphs are all vertical
 * bars over time, which is the one thing a volume profile is not — the whole
 * point of the module is that it turns the chart on its side.
 */
export const VolumeIcon: Icon = ({ size = 24, color = 'currentColor', className, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    <path d="M4 4h9" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    <path d="M4 8h14" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    <path d="M4 12h6" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    <path d="M4 16h11" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    <path d="M4 20h5" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    <path d="M21 3v18" stroke={color} strokeWidth="1.7" strokeLinecap="round" opacity="0.45" />
  </svg>
);
